module.exports = __webpack_public_path__ + "img/2_02.0c9e6911.jpg";